import { LOCALE_EN } from "@growtherapy/i18n";
import telehealthCoreEn from "./en/telehealth-core.json";

export const NS_TELEHEALTH_CORE = "telehealth-core";

const enResources = {
  [NS_TELEHEALTH_CORE]: telehealthCoreEn,
};

export const i18nResources = {
  [LOCALE_EN]: enResources,
};
